require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity.json") })
        }
      }, "path---blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity!./.cache/json/blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity.json
// module id = 276
// module chunks = 231608221292675